import { render, staticRenderFns } from "./PublicDeveloperNewsList.vue?vue&type=template&id=7944eca0&"
import script from "./PublicDeveloperNewsList.vue?vue&type=script&lang=js&"
export * from "./PublicDeveloperNewsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports